// Los CDR y timestamps del backend vienen en UTC SIN marcador de zona
// ("2026-07-14T23:15:19" o "2026-07-14 23:15:19"). new Date() de un string así lo
// interpreta como hora LOCAL → en el panel se veían ~5h adelantados. Acá se fuerza UTC
// y se formatea en hora de Ecuador (America/Guayaquil = -5, sin horario de verano).
const TZ = "America/Guayaquil";

// String UTC-naive (o ya con zona) → Date con el instante correcto.
export function parseUTC(d) {
  let s = String(d).trim().replace(" ", "T");
  if (!/[zZ]|[+-]\d\d:?\d\d$/.test(s)) s += "Z"; // sin zona → es UTC → marcar Z
  return new Date(s);
}

// Formatea una fecha UTC del backend en hora de Ecuador.
export function fmtFechaEC(d, { seconds = false } = {}) {
  if (!d) return "—";
  try {
    return parseUTC(d).toLocaleString("es-EC", {
      timeZone: TZ, day: "2-digit", month: "short",
      hour: "2-digit", minute: "2-digit",
      ...(seconds ? { second: "2-digit" } : {}), hour12: false,
    });
  } catch { return String(d); }
}

// Desde el 2026-09-16 el server corre en America/Guayaquil y las columnas DATETIME de
// MySQL (cdr.calldate y compañía) guardan la hora LOCAL, no UTC. Tratarlas con parseUTC
// les resta 5 h. Estas dos son para esos campos: sin zona → es hora de Ecuador (-05).
export function parseEC(d) {
  let s = String(d).trim().replace(" ", "T");
  if (!/[zZ]|[+-]\d\d:?\d\d$/.test(s)) s += "-05:00";
  return new Date(s);
}

export function fmtCdrEC(d, { seconds = false } = {}) {
  if (!d) return "—";
  try {
    return parseEC(d).toLocaleString("es-EC", {
      timeZone: TZ, day: "2-digit", month: "short",
      hour: "2-digit", minute: "2-digit",
      ...(seconds ? { second: "2-digit" } : {}), hour12: false,
    });
  } catch { return String(d); }
}
